(function () {
  'use strict';

  function activate(button) {
    if (!button || button.dataset.boVideoLoaded === 'true') return;
    var videoId = button.getAttribute('data-bo-video-id');
    if (!videoId) return;

    button.dataset.boVideoLoaded = 'true';
    var iframe = document.createElement('iframe');
    iframe.className = 'bo-video-facade__iframe';
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&playsinline=1';
    iframe.title = button.getAttribute('data-bo-video-title') || 'Video Baby On';
    iframe.width = '640';
    iframe.height = '360';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    button.replaceWith(iframe);
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-bo-video-facade]') : null;
    if (!button) return;
    event.preventDefault();
    activate(button);
  });
})();
